import { EngineCache } from './engineCache'

/**
 * Cache rules engines by question ID.
 */
export default new EngineCache()
